import React, { useState, useEffect } from 'react';
import { DadosExposicaoVitimaHumanaDGrupoASpec } from '@datatox-bi/util';
import DashboardMongo from '../../components/Dashboard/DashboardMongo';
import usePersistedState from '../../components/common/usePersistedState';

let configFiltroSecundario = DadosExposicaoVitimaHumanaDGrupoASpec;

/**
 * RN - Regra de negócio para permitir a pesquisa pelos administradores.
 */
const validarFiltros = () => {
    return true;
};

function DadosExposicaoVitimaHumanaDGrupoAPainel() {
    const [filtrosSecundarios, setFiltrosSecundarios] = usePersistedState('filtro', configFiltroSecundario.filtros);
    const [disabledButton, setDisabledButton] = useState(false);

    useEffect(() => {
        const valid = validarFiltros();
        setDisabledButton(!valid);
    }, [filtrosSecundarios]);

    return (
        <DashboardMongo
            title={configFiltroSecundario.title}
            configFiltroSecundario={configFiltroSecundario}
            disabledButton={disabledButton}
            filtrosSecundarios={filtrosSecundarios}
            setFiltrosSecundarios={setFiltrosSecundarios}
            preFiltrosServer={DadosExposicaoVitimaHumanaDGrupoASpec.preFiltrosServer}
        />
    );
}

export default DadosExposicaoVitimaHumanaDGrupoAPainel;
